import { createStore, applyMiddleware, compose } from "redux";

import createSagaMiddleware from "redux-saga";
import thunk from "redux-thunk";
import rootReducer from "../reducers";
let store;

const sagaMiddleware = createSagaMiddleware();
const middleware = [thunk];

export const configureStore = (initialState) => {
  const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__()
    : compose;

  store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      process.env.NODE_ENV === "development" ? reduxDevTools : compose
    )
  );

  return store;
};

export default store;
